// import * as apis from "./PCF.queries";
import * as queries from "./Form.queries";
import * as mutations from "./Form.mutations";
// import * as mutations from "./POR.mutations";

export default { ...queries, ...mutations };
